<!--
 * @Author: yzf
 * @Date: 2020-09-22 18:03:32
 * @LastEditTime: 2020-09-22 20:27:07
 * @LastEditors: yzf
 * @Description: 这是文件
 * @FilePath: /alex/Volumes/project/hex/wuwei/src/views/other/census/index.vue
 * @大威天龙,世尊地藏,般若诸佛,般若巴麻空,没有bug
-->
<template>
  <div id="census">
    <div class="table-wrap">
      <div class="filters">
        <div class="filter">
          <a-input placeholder="请输入关键词" v-model="query" @keydown.enter="getData"/>
        </div>
        <div class="export item" @click="exportExcel">
          <a-button>
            导出excel
          </a-button>
        </div>
      </div>
      <div class="content">
        <div class="headers">
          <div
            class="items header"
            v-for="head in headers"
            :key="head.type"
            :title="head"
            @click='sortHeder(head.type)'
          >
            <div>
              {{head.name}}
            </div>
            <div class="sort">
              <div class="up" :class='{active: sortType === head.type && sortDirection}'>
                <a-icon type="caret-up" />
              </div>
              <div class="down" :class='{active: sortType === head.type && !sortDirection}'>
                <a-icon type="caret-down" />
              </div>
            </div>
          </div>
        </div>
        <div class="lists" v-show="lists.length">
          <div class="list" v-for="(list, listIdx) in lists" :key="listIdx">
            <div
              class="items"
              v-for="(k, v, itemIdx) in list"
              :key="itemIdx"
            >
              {{list[headers[itemIdx].type]}}
            </div>
          </div>
        </div>
        <div class="none" v-show="!lists.length">
          <span>暂无数据</span>
        </div>
      </div>
      <div class="footer">
        <div class="pagination">
          <div
            class="page control"
            :class="{disabled:pagination == 1}"
            @click='page("prev")'
          >
            ＜
          </div>
          <div
            class="page"
            v-for="i in max < 5 ? max : 5"
            :key="i"
            :class="{active: pagination == start+i}"
            @click="page(start+i)"
          >
            {{start + i}}
          </div>
          <div
            class="page control"
            :class="{disabled:pagination == max}"
            @click='page("next")'
          >
            ＞
          </div>
          <a-input class="page input" v-model="setPagination" @keydown.enter="enter"/>
          <div class="page total" @click="page(max)">共{{max}}页</div>
        </div>
        <a-select :default-value="pageSizes[0].value" style="width: 120px" @change="changePageSize">
          <a-select-option v-for="size in pageSizes" :value="size.value" :key='size.value'>
            {{size.key}}
          </a-select-option>
        </a-select>
      </div>
      <div class="loading" v-show="loading">
        <div class="loading-text">
          <div class="text">加载中</div>
          <div class="circle">
            <div
              class="item"
              v-for="i in 3"
              :class="{show: circleCount>=i}"
              :key="i"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'census',
  data () {
    return {
      headers: [{
        type: 'project_name',
        name: '项目名称'
      }, {
        type: 'appCount',
        name: '端'
      }, {
        type: 'functionCount',
        name: '功能'
      }, {
        type: 'pageCount',
        name: '页面'
      }, {
        type: 'controlCount',
        name: '控件'
      }, {
        type: 'tableCount',
        name: '表'
      }, {
        type: 'fieldsCount',
        name: '表字段'
      }, {
        type: 'flowCount',
        name: '流程图'
      }, {
        type: 'optionCount',
        name: '流程图节点'
      }, {
        type: 'project_id',
        name: '项目id'
      }, {
        type: '_id',
        name: 'id'
      }],
      lists: [],
      search: '',
      pagination: 1,
      pageSize: 5,
      pageSizes: [{
        key: '每页5条',
        value: 5
      }, {
        key: '每页10条',
        value: 10
      }, {
        key: '每页15条',
        value: 15
      }, {
        key: '每页20条',
        value: 20
      }, {
        key: '每页50条',
        value: 50
      }, {
        key: '每页100条',
        value: 100
      }],
      setPagination: 1,
      setPage: '',
      max: 0,
      loading: false,
      circleCount: 1,
      circleInterval: {},
      circleAdd: true,
      sortType: 'pageCount',
      sortDirection: true,
      query: ''
    }
  },
  computed: {
    start () {
      if (this.max <= 5) {
        return 0
      }
      if (this.pagination < 3) {
        return 0
      } else if (this.pagination > this.max - 3) {
        return this.max - 5
      } else {
        return this.pagination - 3
      }
    }
  },
  mounted () {},
  methods: {
    exportExcel () {
      this.$post('/api/project/export_project').then(data => {
        window.open(data)
      })
    },
    sortHeder (type) {
      if (type === this.sortType) {
        this.sortDirection = !this.sortDirection
      } else {
        this.sortDirection = true
        this.sortType = type
      }
      this.getData()
    },
    page (type) {
      switch (type) {
        case 'next':
          if (this.pagination < this.max) {
            this.pagination++
          }
          break
        case 'prev':
          if (this.pagination > 1) this.pagination--
          break
        default:
          this.pagination = type * 1
      }
    },
    enter () {
      if (
        isNaN(this.setPagination) ||
              this.setPagination < 0 ||
              this.setPagination > this.max
      ) {
        this.$message.warn('输入的值错误,请输入在合法范围内的数值')
      } else {
        this.pagination = this.setPagination * 1
      }
    },
    getData () {
      this.loading = true
      const data = {
        pageIndex: this.pagination,
        pageSize: this.pageSize,
        sorter: this.sortDirection ? 1 : -1,
        sortName: this.sortType,
        query: this.query
      }
      this.$post('/api/project/projectInfo', data).then(data => {
        this.loading = false
        this.max = Math.ceil(data.totalCount && data.totalCount / this.pageSize)
        this.lists = data.list
      })
    },
    changePageSize (v) {
      this.pageSize = v
      this.getData()
    }
  },
  watch: {
    pagination: {
      immediate: true,
      handler (n, o) {
        this.setPagination = this.pagination * 1
        this.getData()
      }
    },
    loading (n) {
      if (n) {
        this.circleInterval = setInterval(() => {
          if (this.circleAdd) {
            this.circleCount++
            if (this.circleCount >= 3) {
              this.circleAdd = !this.circleAdd
            }
          } else {
            this.circleCount--
            if (this.circleCount <= 0) {
              this.circleAdd = !this.circleAdd
            }
          }
        }, 600)
      } else {
        clearInterval(this.circleInterval)
        this.circleAdd = true
        this.circleCount = 1
      }
    }
  }

}
</script>

<style lang="less" scoped>
#census {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  .table-wrap {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 80vw;
    height: 80vh;
    background: #fff;
    padding: 24px;
    border-radius: 20px;
    overflow: hidden;
    & > div {
      flex-shrink: 0;
    }
    .items {
      flex-shrink: 0;
      flex-grow: 1;
      width: 100px;
      line-height: 20px;
      padding: 16px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8e8e8;
      transition: 0.3s;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      height: auto;
      justify-content: flex-start;
    }
    .filters {
      display: flex;
      line-height: 30px;
      .item {
        padding: 0 4px;
        min-width: 22px;
        border-radius: 4px;
        margin-right: 8px;
        user-select: none;
        transition: 0.3s;
        &:hover {
          color: rgba(250, 136, 61, 0.8);
          border-color: rgba(250, 136, 61, 0.8);
        }
      }
    }
    .content {
      margin-top: 16px;
      overflow: auto;
      height: 100px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      &::-webkit-scrollbar {
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        height: 4px;
        background: lightgray;
        border-radius: 2px;
      }
      .headers {
        display: flex;
        background: #fafafa;
        width: max-content;
        min-width: 100%;
        font-weight: bold;
        flex-shrink: 0;
        user-select: none;
        .items {
          background: none;
          box-shadow: none;
          &:hover {
            background: #f2f2f2;
          }
          .sort {
            margin-left: 8px;
            div {
              height: 10px;
              position: relative;
              color: #bfbfbf;
              i {
                position: absolute;
                left: 0;
                top: 0;
              }
            }
            .active {
              color: #ffa866;
            }
          }
        }
      }
      .lists {
        width: max-content;
        min-width: 100%;
        height: 100px;
        flex-grow: 1;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: lightgray;
          border-radius: 2px;
        }
        .list {
          display: flex;
          &:hover {
            background-color: #fff8f0;
          }
        }
      }
      .none {
        display: flex;
        justify-content: center;
        font-size: 60px;
        align-items: center;
        flex-grow: 1;
        color: rgba(0, 0, 0, 0.6);
      }
    }
    .footer {
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
      &>div {
        margin-left: 8px;
      }
      .pagination {
        width: max-content;
        display: flex;
        text-align: center;
        line-height: 30px;
        color: rgba(0, 0, 0, 0.65);
        .page {
          padding: 0 4px;
          min-width: 32px;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          margin-left: 8px;
          user-select: none;
          transition: 0.3s;
          &:hover {
            color: rgba(250, 136, 61, 0.8);
            border-color: rgba(250, 136, 61, 0.8);
          }
          &.active {
            color: #ffa866;
            border-color: #ffa866;
          }
          &.input {
            width: 44px;
          }
          &.total {
            border: none;
          }
          &.control {
            font-size: 12px;
          }
          &.disabled {
            color: #d9d9d9;
            border-color: #d9d9d9;
            cursor: no-drop;
          }
        }
      }
    }
    .loading {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      .loading-text {
        display: flex;
        .text {
          font-size: 40px;
          color: rgba(0, 0, 0, 0.6);
        }
        .circle {
          display: flex;
          align-items: center;
          min-width: 72px;
          .item {
            margin-left: 12px;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.6);
            transition: 0.3s;
            opacity: 0;
            &.show {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
@keyframes run {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

</style>
